<template>
  <div>
    <div v-if="!showKpiFlow">
      <project-admin-quick-buttons v-if="!activityId" hiddenOption="nadieporahora-kpis-esta-fuera-de-esto" />
      <b-tabs type="is-boxed">
        <b-tab-item :label="$t('kpis_weekly')">
          <kpis
            :projectId="resolvedProjectId"
            :activity-id="activityId"
            @ActivityHomeShowFullWidth="openKpiFlow"
          />
        </b-tab-item>
        <b-tab-item :label="$t('kpis_daily')">
          <KpisDaily
            :projectId="resolvedProjectId"
            :activityId="activityId"
            @ActivityHomeShowFullWidth="openKpiFlow"
          />
        </b-tab-item>
      </b-tabs>
    </div>
    <KpiFlowManager
      v-if="showKpiFlow"
      ref="kpiFlow"
      @closeWeekly="closeKpiFlow"
      @closeDaily="closeKpiFlow"
      :initialPayload="kpiFlowPayload"
    />
  </div>
</template>

<script>
import Kpis from './kpis.vue'
import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
import KpisDaily from './kpis-daily/kpis-daily.vue'
import { mapGetters } from "vuex"
import KpiFlowManager from './kpi-flow-manager.vue'

export default {
  middleware: "auth",
  title: "kpis",
  menuOption: "0-2",
  
  props: {
    activityId: {
      type: [Number, String],
      default: null
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  components: {
    Kpis,
    ProjectAdminQuickButtons,
    KpisDaily,
    KpiFlowManager
  },
  data() {
    return {
      showKpiFlow: false,
      kpiFlowPayload: null
    }
  },
  computed: {
    ...mapGetters({
      navData: "app/navData",
    }),
    resolvedProjectId() {
      if (this.projectId) {
        return parseInt(this.projectId)
      }
      if (this.$route.params.project_id) {
        return parseInt(this.$route.params.project_id)
      }
      return parseInt(this.navData.project_id)
    }
  },
  methods: {
    openKpiFlow(payload) {
      this.kpiFlowPayload = payload
      this.showKpiFlow = true
    },
    closeKpiFlow() {
      this.showKpiFlow = false
      this.kpiFlowPayload = null
    }
  }
}
</script>